import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPortalAccessToken } from "../../../store/slice/portalAuthSlice";
import { isAccessTokenExpired } from "../../../store/slice/portalAuthUtils";

/**
 * PortalAuthRedirect
 *
 * Thin wrapper around auth routes (login, forgot-password, reset_password, accept_invite).
 *
 * Responsibilities:
 *   - If the user already has a valid, non-expired access token → redirect them
 *     to /catalog so they don't see the login page unnecessarily.
 *   - Otherwise → render the auth page (Outlet).
 *
 * here we attempt to check if the user is already authenticated and has a valid access token. If so, we redirect them to the catalog page. If not, we render the auth page (Outlet) for login, forgot-password, reset_password, or accept_invite.
 */
const PortalAuthRedirect = () => {
  const { subdomain } = useParams();
  const accessToken = useSelector(state => selectPortalAccessToken(state, subdomain));

  // Already logged in with a valid token → send to catalog.
  // We do NOT check for hasRichData here because on a new tab, rich data is empty.
  // The /catalog route (PortalPrivateRoutes) will handle fetching the rich data automatically.
  if (accessToken && !isAccessTokenExpired(accessToken)) {
    return <Navigate to={`/portal/${subdomain}/catalog`} replace />;
  }

  return <Outlet />;
};

export default PortalAuthRedirect;
